import styled, {css} from "styled-components";

export const MoreDetailsContainerBox = styled.div<{isClickable: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    align-content: flex-end;
    padding-right: 4px;
  ${
          props => props.isClickable
                  ? css`cursor: pointer;` : ''
  }
`